module.exports = __webpack_public_path__ + "media/Home_FDMT_Workshop_Teaching.4c3fd177.mp4";